// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image {
  position: relative;
  display: block;
  max-width: 100%;
  height: auto;
}
.image__icon {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: rgb(var(--colour-text-and-icon-4, 146, 146, 146));
}
.image--fallback {
  padding-bottom: 100%;
  background: rgb(var(--colour-neutral-2, 245, 245, 245));
}
.image--fallback img {
  position: absolute;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  margin: -1px;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./node_modules/@ingka/image/dist/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,wDAAwD;AAC1D;AACA;EACE,oBAAoB;EACpB,uDAAuD;AACzD;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".image {\n  position: relative;\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n.image__icon {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  color: rgb(var(--colour-text-and-icon-4, 146, 146, 146));\n}\n.image--fallback {\n  padding-bottom: 100%;\n  background: rgb(var(--colour-neutral-2, 245, 245, 245));\n}\n.image--fallback img {\n  position: absolute;\n  height: 1px;\n  width: 1px;\n  overflow: hidden;\n  clip: rect(1px, 1px, 1px, 1px);\n  margin: -1px;\n  white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
